<!-- 角色列表 -->
<template>
<div>
	<!-- 标题 -->
	<div class="page-title">VUE路径管理页面</div>
	
	<div style="display: flex;align-items: center;flex-wrap: wrap;margin: 10px 0 15px;position: sticky;left: 30px;z-index: 5;width: 860px;">
		<a-button @click="addButton" style="background-color: #67c23a;border-color: #67c23a;" type="primary">+ 新增</a-button>
	</div>
	
	<div>
		<!-- 表头 -->
		<div class="table-th" :style="{'width': table_scroll_width + 'px'}">
			<div  v-for="(item,index) in rableTitle" :key="index" >
				<div class="table-th-cell" 
				:style="{'width':item.width + 'px',}">
					{{item.title}}
				</div>
			</div>
		</div>
		
		<!-- 表格内容 -->
		
			<div v-for="(item,index) in tableShowData" :key="index" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
				<!-- ID -->
				<div class="table-td-cell" :style="{'width':rableTitle[0].width + 'px'}">
					{{item.id}}
				</div>
				<!-- VUE路径名称 -->
				<div class="table-td-cell" :style="{'width':rableTitle[1].width + 'px'}">
					{{item.name}}
				</div>
				<!-- VUE路径 -->
				<div class="table-td-cell" :style="{'width':rableTitle[2].width + 'px'}">
					{{item.vue_url}}
				</div>
				<!-- 角色 -->
				<div class="table-td-cell" :style="{'width':rableTitle[3].width + 'px'}" style="display: flex;flex-wrap: wrap;">
					<!-- {{item.role}} -->
					<div v-for="(item,index) in item.role" :key="index" style="margin-right: 10px;margin-bottom: 3px;">
						{{item}}
					</div>
				</div>
				<!-- 关联菜单项 -->
				<div class="table-td-cell" :style="{'width':rableTitle[4].width + 'px'}" style="display: flex;flex-wrap: wrap;">
					<!-- {{item.menus}} -->
					<div v-for="(item,index) in item.menus" :key="index" style="margin-right: 10px;margin-bottom: 3px;">
						{{item}}
					</div>
				</div>
				<!-- 操作 -->
				<div @click="editTable(index,item)" class="table-td-cell" :style="{'width': rableTitle[5].width + 'px'}" style="color: #62a8ea;cursor: pointer;">
					编辑
				</div>
				
			</div>
		
		
		<div v-show="tableShowData.length === 0" style="text-align: center;text-align:center;padding: 80px 0 50px;" :style="{'width': table_scroll_width + 'px'}">
			<a-icon style="font-size: 70px;color: #999;" type="file-search" />
			
			<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
		</div>
		
	</div>
	<!-- 分页 -->
	<div :style="{'width': table_scroll_width + 'px',}" style="text-align: center;margin-top: 30px;">
		
		<a-pagination v-model="r_page" :pageSize="r_limit" :total="table_total" @change="paginationChange" hideOnSinglePage />
		
	</div>
	
	<!-- 新增/编辑的侧边栏 -->
	<a-drawer
	  :title="drawer_title"
	  width="550px"
	  placement="right"
	  :closable="false"
	  :visible="visible"
	  @close="onCloseDrawer"
	>
		<div style="padding: 0;">
			
			<div class="form-cell-box">
				<div class="class-title">名称<span class="required-hint">*</span></div>
					
				<a-input v-model="x_name" placeholder="请输入" style="width: 350px;"  />
			</div>
			
			<div class="form-cell-box">
				<div class="class-title">路径<span class="required-hint">*</span></div>
				
				<a-input v-model="x_vue_url" placeholder="请输入" style="width: 350px;"  />	
				<!-- <a-select :value="x_vue_url" style="width: 350px" placeholder="未选择" showSearch
				 @change="handleChangeV($event)">
					<a-select-option  v-for="(value_s,key_s) in vueSelect" :key="key_s" :value="value_s.id">
						{{value_s.vue_url}} -- {{value_s.name}}
					</a-select-option>
				</a-select> -->
			</div>
			
			
			<div class="form-cell-box">
				<div class="class-title">角色</div>
				<a-select
					:value="x_role_ids"
				    mode="multiple"
				    style="width: 350px"
				    placeholder="请选择"
				    @change="handleChangeB"
					:filter-option="filterOption"
					:getPopupContainer="getsPopupContainer"
					allowClear
				  >
				    <a-select-option v-for="(item,key) in roleList" :key="key" :value="key">
				      {{item}}
				    </a-select-option>
				</a-select>
			</div>
			
			<div style="color: red;height: 23px;width: 100%;">{{add_form_hint}}</div>
			
			<div class="form-cell-box" style="margin-top: 30px;padding-left: 20px;">
				<a-button @click="addRequest" :loading="add_button_loading" type="primary" style="margin-right: 20px;">确认</a-button>
				<a-button @click="onCloseDrawer">取消</a-button>
			</div>
		</div>
	
	</a-drawer>
	
	
	
	<!-- 加载中 -->
	<div class="loading-box" v-show="search_button_loading">
		<a-spin size="large" />
	</div>
</div>
</template>

<script>
import { vuePathList, roleRouteInfo, roleSetRoute, UserSelectRole, vuePathAdd, vuePathEdit, menuVueSelect } from '@/request/api'

export default {
	name: 'vuePath_',
	components: {
		
	},
	data() {
		return {
			// 表格部分内容
			// 表格的表头，规定宽度和要用的其他信息
			rableTitle: [
				{title:"ID", width:80, type:"id", }, // sort_status: 0为默认，1为下面的三角高亮，2位上面的三角高亮
				{title:"VUE路径名称", width:220, type:"name", },
				{title:"VUE路径", width:180, type:"vue_url", },
				{title:"角色", width:200, type:"role", },
				{title:"关联菜单项", width:220, type:"menus", },
				{title:"操作", width:100, type:"cz", },
			],
			tableShowData: [],
			table_scroll_width: 1000,
			search_button_loading: false,
			
			r_page: 1,
			r_limit: 50,
			table_total: 0,
			
			drawer_title: "新增", // 侧边栏标题
			visible: false,
			add_button_loading: false, // 新增侧边栏的确认按钮加载状态
			add_form_hint: "", // 侧边栏新增表单的验证提示
			
			x_id: "", // id
			x_name: "", // 角色名称
			x_vue_url: "", // vue路径
			x_role_ids: [], // 角色id
			
			routeGroup: [], // 路由列表
			
			roleList: {}, // 角色下拉列表
			vueSelect: {},
		}
	},
	mounted(){
		let that = this
		
		let nn = 0
		that.rableTitle.forEach((res,index)=>{
			nn = nn + res.width
		})
		that.table_scroll_width = nn + 30
		
		// 获取角色的下拉列表
		UserSelectRole().then(res=>{
			// console.log("角色下拉列表",res.data.data.list)
			let data = res.data.data.list
			let k_data = Object.keys(data)
			let r_data = []
			k_data.forEach(res=>{
				let obj = {
					key : res,
					value : data[res]
				}
				r_data.push(obj)
			})
			that.roleList = res.data.data.list
		})
		
		// 获取vue下拉
		menuVueSelect().then(res=>{
			console.log("获取vue下拉",res);
			that.vueSelect = res.data.data.list
		})
		
		that.searchButton()
		
		
	},
	methods:{
		
		filterOption(input, option) {
		    return (
		        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
		    );
		},
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		// 角色下拉
		handleChangeB(value) {
			this.x_role_ids = value
		    console.log(value);
		},
		// 侧边栏，vue路径选择
		handleChangeV(e){
			console.log(e)
			let that = this
			this.x_vue_url = e
			
			// 获取路由对应的名字/页面标题
			// this.vueUrl.forEach(function(res_r,index_r){
			// 	if(res_r.path == e){
			// 		that.vueData[index].name = res_r.name
			// 	}
			// })
		},
		// 搜索
		searchButton(){
			let that = this
			
			that.search_button_loading = true
			
			vuePathList({
				page: that.r_page,
				limit: that.r_limit,
			}).then(res=>{
				console.log("列表结果",res.data.data)
				that.search_button_loading = false
				that.table_total = res.data.data.total || 0
				if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){
					that.$message.success('搜索成功');
					
					
					
					that.tableShowData = res.data.data.data
				}
				else {
					if(res.data.code === 401){ // 未登录
						localStorage.removeItem("access_token");
						that.$router.replace({name: 'login',params: {type:'not_log'}})
					}
					else {
						that.$message.error(`其他错误：${res.data.msg}`);
					}
				}
			})
		},
		// 新增
		addButton(){
			let that = this
			that.drawer_title = "新增"
			that.visible = true
		},
		// 编辑
		editTable(index,item){
			let that = this
			console.log(item);
			that.drawer_title = "编辑"
			that.x_id = item.id
			this.x_name = item.name // 名称
			this.x_vue_url = item.vue_url
			
			this.x_role_ids = Object.keys(item.role)
			// console.log(Object.keys(item.role));
			that.visible = true
			
		},
		
		// 侧边栏的确认按钮
		addRequest(){
			let that = this
			if(!that.x_name){
				that.add_form_hint = "请填写vue路径名称"
			}
			else if(!that.x_vue_url){
				that.add_form_hint = "请选择vue路径"
			}
			
			else {
				that.add_button_loading = true
				that.add_form_hint = ""
				
				let rrr = []
				
				
				
				// function setR(id){
				// 	roleSetRoute({
				// 		role_id: id,
				// 		route_ids: i_data
				// 	}).then(res_r=>{
				// 		console.log("角色分配权限",res_r)
				// 		that.add_button_loading = false
				// 		that.onCloseDrawer()
				// 		that.$message.success('操作成功');
				// 		that.searchButton()
				// 	})
				// }
				
				if(that.drawer_title == "新增"){
					// 新增
					vuePathAdd({
						name: that.x_name,
						vue_url: that.x_vue_url,
						roles: that.x_role_ids,
					}).then(res=>{
						console.log("新增",res)
						
						if(res.data.code == 0){
							that.add_button_loading = false
							that.onCloseDrawer()
							that.$message.success('操作成功');
							that.searchButton()
						}
						else {
							that.add_button_loading = false
							that.$message.error(res.data.msg || "请求失败");
						}
					})
					.catch(err=>{
						that.add_button_loading = false
						console.log(err)
						that.$message.error("请求失败，可能是网络出现问题");
					})
				}
				else if(that.drawer_title == "编辑"){
					vuePathEdit({
						id: that.x_id,
						name: that.x_name,
						vue_url: that.x_vue_url,
						roles: that.x_role_ids,
					}).then(res=>{
						console.log("编辑",res)
						if(res.data.code == 0){
							that.add_button_loading = false
							that.onCloseDrawer()
							that.$message.success('操作成功');
							that.searchButton()
						}
						else {
							that.add_button_loading = false
							that.$message.error(res.data.msg || "请求失败");
						}
					})
					.catch(err=>{
						that.add_button_loading = false
						console.log(err)
						that.$message.error("请求失败，可能是网络出现问题");
					})
				}
				
				
			}
		},
		// 侧边栏关闭
		onCloseDrawer(){
			if(this.add_button_loading){ // 新增中或编辑中不准关闭侧边栏
				return
			}
			
			this.x_name = "" // 角色名称
			this.x_vue_url = "" // 路径
			this.x_role_ids = []
			this.add_form_hint = ""
			
			this.visible = false
		},
		
		// 分页
		paginationChange(e){
			let that = this
			this.r_page = e
			that.searchButton()
			
		},
	},
}
</script>

<style scoped>

.class-title {
	font-size: 14px;
	margin-right: 25px;
	width: 60px;
	color: #333;
	text-align: right;
}
</style>